/* eslint-disable-next-line flowtype/require-valid-file-annotation */
export const ModalNames = {
  blockConfirmation: 'blockConfirmation',
  blockWarning: 'blockWarning',
  editProfile: 'editProfile',
  reportBug: 'reportBug',
  reportBugSuccess: 'reportBugSuccess',
  reportBugFailure: 'reportBugFailure',
  sendProfile: 'sendProfile',
  signupLogin: 'signupLogin',
  unblock: 'unblock',
};

export default ModalNames;
